<div class="wrapper">
  <div class="current-term"></div>
  <div class="new-term"></div>
  <div class="term-reduction" [style.width]="newTermReductionPercentage + '%'"></div>
</div>
<div class="term-reduction-value">
  <i></i>
  <span>
    <b>{{ currentTerm - newTerm | term }}</b> reduction
  </span>
</div>
